import 'apps/hiring/styles/components/add-opening.scss';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import SavingButton from 'library/components/saving-button';
import withUser from 'util/hoc/with-user';

class InviteEmployeeModalBody extends React.Component {
  state = {
    saving: false
  }

  render() {
    return (
      <div className="hiring-modal add-opening-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <p>Invite Employees</p>
            <a onClick={this.props.onClose} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body">
          <h1>Add Employee</h1>
        </div>
        <div className="hiring-modal-footer">
          <SavingButton onClick={()=>{}} saving={this.state.saving} type="submit">INVITE EMPLOYEE</SavingButton>
        </div>
      </div>
    );
  }
}

export default withUser(InviteEmployeeModalBody);
